import Lightbox from 'bs5-lightbox'

export default (element) => {
    element.addEventlistener('click', Lightbox.initialize())
}